export const YES_NO_QUESTIONS = [
  {
    key: 'surety_fidelity_bond',
    question: 'Have you ever had a surety/fidelity bond?',
    requiresExplanation: false,
  },
  {
    key: 'felonies',
    question: 'Have you ever been convicted of a felony?',
    requiresExplanation: true,
  },
  {
    key: 'currently_working',
    question: 'Are you currently employed?',
    requiresExplanation: false,
  },
  {
    key: 'two_jobs',
    question: 'Are you going to work two jobs?',
    requiresExplanation: false,
  },
  {
    key: 'failed_drug_test',
    question: 'Have you had any failed drug tests in the last 3 years?',
    requiresExplanation: true,
  },
  {
    key: 'refused_drug_test',
    question: 'Have you refused a drug test in the last 3 years?',
    requiresExplanation: true,
  },
  {
    key: 'license_other_states',
    question: "Have you ever held a driver's license or permit in any other state?",
    requiresExplanation: false,
    specialType: 'other_state_license',
  },
  {
    key: 'license_suspended_revoked',
    question: "Has your driver's license, permit, or driving privilege ever been suspended or revoked?",
    requiresExplanation: true,
  },
  {
    key: 'denied_license',
    question: "Have you ever been denied a driver's license, permit, or driving privilege?",
    requiresExplanation: true,
  },
  {
    key: 'traffic_convictions',
    question: 'Have you had any traffic convictions (not parking violations) in a commercial motor vehicle in the last 3 years?',
    requiresExplanation: true,
  },
  {
    key: 'accidents_cmv',
    question: 'Have you had any accidents in a commercial motor vehicle in the last 3 years?',
    requiresExplanation: true,
  },
  {
    key: 'fatality_hazmat',
    question: 'Did any of those accidents involve a fatality or a hazmat spill?',
    requiresExplanation: true,
    conditionalOn: { key: 'accidents_cmv', value: 'yes' },
  },
];
